import React, { useEffect, useState } from "react";
import { faCheck, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import Utils from "../../configs/Utils";

const getValueByPath = (object, path) => {
  if (!object || !path) return undefined;

  return path.split(".").reduce((currentValue, key) => {
    if (currentValue == null) return undefined;
    return currentValue[key];
  }, object);
};

const QuickEdit = ({
  path,
  pathParams,
  param,
  defaultValue,
  placeholder = "",
  onUpdate = () => {},
}) => {
  const [value, setValue] = useState("");
  const [process, setProcess] = useState("off");

  useEffect(() => {
    setValue(defaultValue ?? "");
  }, [defaultValue]);

  const onDoubleClickHandle = () => {
    setProcess("open");
  };

  const onSubmitHandle = async (e) => {
    e.preventDefault();
    setProcess("loading");
    if (value.toString().trim().length) {
      try {
        const payload = {};
        payload[param] = value;
        const options = {
          type: "put",
          path: path,
          payload: payload,
          ...(pathParams && { pathParams }),
        };

        const data = await Utils._apiRequest(options);
        if (data.errors?.message) {
          throw new Error(data.errors.message);
        } else {
          const updatedValue = getValueByPath(data, param);
          setValue(updatedValue ?? "");
          setProcess("off");
          if (onUpdate) {
            onUpdate(param, value);
          }
        }
      } catch (error) {
        alert(error.message);
        setProcess("open");
      }
    }
  };

  return (
    <>
      {process !== "off" ? (
        <div style={{ maxWidth: "500px" }}>
          <Form
            onSubmit={onSubmitHandle}
            className="d-flex align-items-center gap-2 mt-1 mb-1"
          >
            <Form.Control
              disabled={process === "loading"}
              size="sm"
              className="mb-0"
              defaultValue={defaultValue}
              onChange={(e) => {
                setValue(e.target.value);
              }}
            />

            <Button
              size="sm"
              disabled={process === "loading"}
              type="submit"
              className="mb-0"
            >
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </Form>
        </div>
      ) : (
        <span
          style={{ cursor: "pointer", textDecoration: "underline" }}
          className="quickEdit"
          onDoubleClick={onDoubleClickHandle}
        >
          {value?.toString().trim().length ? value : placeholder}
          <FontAwesomeIcon className="ms-2" icon={faPen} size="xs" />
        </span>
      )}
    </>
  );
};

export default QuickEdit;
